import React, { useState, useLayoutEffect, Fragment } from 'react';
var Delay = function (_a) {
    var ms = _a.ms, children = _a.children;
    var _b = useState(false), shouldDisplay = _b[0], setShouldDisplay = _b[1];
    useLayoutEffect(function () {
        var timeout = setTimeout(function () {
            setShouldDisplay(true);
        }, ms);
        return function () {
            clearTimeout(timeout);
        };
    }, [ms]);
    return React.createElement(Fragment, null, shouldDisplay ? children : null);
};
Delay.displayName = 'Delay';
export default Delay;
//# sourceMappingURL=Delay.js.map